module.exports = __webpack_public_path__ + "static/atlassian-8aade6ef7e29b1652e28584ef3a34d52.png";